<template>
    <div class="row">
        <div class="col p-2">
            <div class="cont-pagination-itg">
                <nav aria-label="...">
                    <ul class="pagination">
                        <li class="page-item" :class="selectedPageC === 1 ? 'disabled': ''">
                            <div class="page-link" @click="afterPagePaginationC">
                                <i class="fa fa-angle-left"></i>
                                <span class="sr-only" id="dbdLeftC"  v-if="paginas.length > 1">Previous</span>
                            </div>
                        </li>
                        <ul class="contenedor-page">
                            <li v-for="(cpaginas, i) in paginas" :key="i" :class="i+1 === selectedPageC ? 'active' : ''" class="page-item cantidad-paginas-itg"  @click="selectedNumberPageC(cpaginas)">
                                <div class="page-link" >{{ cpaginas }}</div>
                            </li>
                        </ul>
                        <li class="page-item" :class="cantidad === selectedPageC ? 'disabled': ''">
                            <div class="page-link" @click="nextPagePaginationC" >
                                <i class="fa fa-angle-right"></i>
                                <span class="sr-only" v-if="paginas.length > 1">Next</span>
                            </div>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
export default {
    name:'pagination',
    props:{
        query: {
            type: Object,
            required: false,
            default: () => ({})
        },
        paginas: {
            type: Array,
            required: false,
            default: () => ({})
        },
        cantidad: {
            type: Number,
            required: false,
            default: () => ({})
        },
        type: {
            type: String,
            required: false,
            default: () => ({})
        },
        filtro: {
            type: String,
            required: false,
            default: () => ({})
        }
    },
    data(){
        return {
            selectedPageC: 1,
            rowsOnPageC: 10
        }
    },
    computed: {
    },
    methods: {
        afterPagePaginationC() {
            this.selectedPageC = this.selectedPageC -1
            this.allObject()
            // if (this.selectedPageC > 1) {
            //     
            //     if (this.selectedPageC === 1) {
            //         document.getElementById('dbdLeftC').style.color = '#e4e4e4'
            //     }

            //     if (this.cantidad > this.selectedPageC) {
            //         document.getElementById('dbdRightC').style.color = '#037a8d'
            //     }
            //      this.allObject()
            // } else if (this.selectedPageC === 1) {
            //     document.getElementById('dbdLeftC').disabled = true
            // } else {
            //     document.getElementById('dbdLeftC').disabled = false
            // }
        },
        nextPagePaginationC() {
            // let calculoPaginasC = Math.ceil(this.paginationC.size / this.rowsOnPageC)
            this.selectedPageC = this.selectedPageC + 1
            this.allObject()
            // if (this.cantidad > this.selectedPageC) {
                
            //     if (this.selectedPageC > 1) {
            //         document.getElementById('dbdLeftC').style.color = '#037a8d'
            //     }

            //     if (this.cantidad === this.selectedPageC) {
            //         document.getElementById('dbdRightC').style.color = '#e4e4e4'
            //     }
                
            // } else if (this.cantidad === this.selectedPageC) {
            //     document.getElementById('dbdRightC').disabled = true
            // } else {
            //     document.getElementById('dbdRightC').disabled = false
            // }
           
        },
        selectedNumberPageC(valor) {
            
            this.selectedPageC = valor

            // if (this.cantidad === this.selectedPageC) {
            //     document.getElementById('dbdRightC').style.color = '#e4e4e4'
            // } else if (this.cantidad > this.selectedPageC) {
            //     document.getElementById('dbdRightC').style.color = '#037a8d'
            // }

            // if (this.selectedPageC > 1) {
            //     document.getElementById('dbdLeftC').style.color = '#037a8d'
            // } else {
            //     document.getElementById('dbdLeftC').style.color = '#e4e4e4'
            // }
             this.allObject()
        },
        allObject() {
            let params;
            if (this.filtro) {
                params = Object.assign({},  { pagina: this.selectedPageC, cantidad: 10, filtrobuscar: this.filtro } )
            } else {
                params = Object.assign({},  { pagina: this.selectedPageC, cantidad: 10 })
            }
            this.$store.dispatch(`${this.type}/getAll`, params)
        }
    },
    mounted() {
    }
}
</script>

<style lang="scss">
        .cont-pagination-itg {
            display: inline-flex;
            font-size: 20px;
            width: 100%;
            justify-content: center;

            .fila {
                padding: 10px;
            }

            .arrow-left-itg {
                color: #e4e4e4;
            }

            .arrow-right-itg {
                color: #037a8d;
            }

            .cantidad-paginas-itg {
                width: 100%;
                height: 40px;
                padding: 0;
                display: grid;
                justify-content: center;
                /*contain: strict;*/
                /*overflow: auto;*/

                ul {
                    padding: 0;
                    list-style: none;
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;

                    li {
                        font-size: 14px;
                        width: 28px;
                        height: 28px;
                        float: left;
                        margin: 0 5px;
                        border-radius: 25px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #037a8d;
                        background-color: #cdeef4;
                    }

                    .active-pagination-itg {
                        color: #cdeef4;
                        background-color: #037a8d;
                        font-weight: bold;
                    }
                }
            }
        }
        .contenedor-page {
            padding: 0;
            display: flex;
        }
</style>